const css = `._1Z7PFq__noWrap,._1Z7PFq__noWrap *{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}._1Z7PFq__fullWidth{width:100%}._1Z7PFq__printLegend{display:none}@media print{._1Z7PFq__legend{display:none}._1Z7PFq__printLegend{display:flex}}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"legend":"_1Z7PFq__legend","fullWidth":"_1Z7PFq__fullWidth","noWrap":"_1Z7PFq__noWrap","printLegend":"_1Z7PFq__printLegend"};
